import Button from '../../../components/base/Button';

export default function CTASection() {
  return (
    <section className="py-20 bg-gradient-to-br from-[#E71B25] to-[#d11620]">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          جاهز تبدأ مشروعك؟
        </h2>
        
        <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto leading-relaxed">
          راسلنا لتحصل على استشارة مجانية وعرض سعر مخصص
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button 
            variant="outline" 
            size="lg" 
            className="bg-white text-[#E71B25] border-white hover:bg-gray-50 shadow-lg whitespace-nowrap"
          >
            طلب عرض سعر
          </Button>
          <Button 
            variant="outline" 
            size="lg" 
            className="bg-transparent border-white text-white hover:bg-white hover:text-[#E71B25] shadow-lg whitespace-nowrap"
            onClick={() => window.location.href = 'mailto:info@vipatradingco.com'}
          >
            مراسلة عبر البريد
          </Button>
        </div>
      </div>
    </section>
  );
}